<app-navbar-style-three></app-navbar-style-three>
<section class="bg-image">
    <div class="container">
        <div class="pt-3 pb-3" *ngIf="!fetchinData">
            <div class="row">
                <div class="col-md-3">
                    <div align="left" style="padding-left: 20px">
                        <p style="font-size: 26px">Acdemic</p>
                    </div>
                    <div class="list-group list-group-flush">
                        <ng-container *ngFor="let item of items">
                            <button
                                [class.active]="selectedItem === item.Url"
                                (click)="selectItem(item.Url)"
                                class="newA linkStyle list-group-item list-group-item-action"
                            >
                                {{ item.Name }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-9">
                    <div style="min-height: 800px">
                        <div>
                            <h3>{{ selectedItemName }}</h3>
                            <hr />

                            <!-- New -->

                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'academic-rules'
                                "
                            >
                                <ng-container
                                    *ngIf="aca_rules == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="aca_rules != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify"
                                            style="padding: 0"
                                        >
                                            <div
                                                class="card"
                                                style="padding: 20px"
                                            >
                                                <div>
                                                    <img
                                                        alt="Message"
                                                        class="img-fluid"
                                                        [src]="
                                                            aca_rules
                                                                .ShowAttachments[0]
                                                                .FilePath
                                                        "
                                                        style="
                                                            height: 300px;
                                                            width: 100%;
                                                            object-fit: cover;
                                                            border-radius: 10px;
                                                        "
                                                    />
                                                </div>

                                                <p
                                                    style="text-align: justify"
                                                    [innerHTML]="
                                                        aca_rules.DetailsEn
                                                    "
                                                ></p>
                                            </div>
                                        </article>
                                    </div>
                                </ng-container>
                            </div>

                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'academic-calendar'
                                "
                            >
                                <ng-container
                                    *ngIf="academic_calender_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Founded</span
                                    >
                                </ng-container>
                                <ng-container
                                    *ngIf="academic_calender_data != null"
                                >
                                    <ng-container
                                        *ngFor="
                                            let data of academic_calender_data;
                                            let i = index
                                        "
                                    >
                                        <!-- <h3>{{ item.TitleEn }}</h3> -->
                                        <div
                                            class="blog-details-desc"
                                            style="
                                                padding: 20px;
                                                border: 2px solid #eeeeee;
                                            "
                                            *ngFor="
                                                let item of data.ShowAttachments
                                            "
                                        >
                                            <div
                                                class="container"
                                                style="margin-bottom: 30px"
                                            >
                                                <div
                                                    class="row align-items-center"
                                                >
                                                    <div
                                                        class="col-lg-4 col-md-12"
                                                    >
                                                        <div
                                                            class="about-image"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                x="0px"
                                                                y="0px"
                                                                width="100"
                                                                height="100"
                                                                viewBox="0 0 50 50"
                                                            >
                                                                <path
                                                                    d="M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z M 15 22 L 15 24 L 35 24 L 35 22 Z M 15 28 L 15 30 L 31 30 L 31 28 Z M 15 34 L 15 36 L 35 36 L 35 34 Z"
                                                                ></path>
                                                            </svg>
                                                        </div>
                                                        <div
                                                            class="about-image"
                                                        >
                                                            <a
                                                                [href]="
                                                                    item.FilePath
                                                                "
                                                                target="_blank"
                                                                style="
                                                                    cursor: pointer;
                                                                    color: var(
                                                                        --mainColor
                                                                    );
                                                                "
                                                                >Open File
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-lg-8 col-md-12"
                                                    >
                                                        <div>
                                                            <div>
                                                                <p class="elip">
                                                                    {{
                                                                        item.Title
                                                                    }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'our-curriculum'
                                "
                            >
                                <ng-container
                                    *ngIf="curriculams == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="curriculams != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify"
                                            style="padding: 0"
                                        >
                                            <div
                                                class="card"
                                                style="padding: 20px"
                                            >
                                                <div>
                                                    <img
                                                        alt="Message"
                                                        class="img-fluid"
                                                        [src]="
                                                            curriculams
                                                                .ShowAttachments[0]
                                                                .FilePath
                                                        "
                                                        style="
                                                            height: 300px;
                                                            width: 100%;
                                                            object-fit: cover;
                                                            border-radius: 10px;
                                                        "
                                                    />
                                                </div>

                                                <p
                                                    style="text-align: justify"
                                                    [innerHTML]="
                                                        curriculams.DetailsEn
                                                    "
                                                ></p>
                                            </div>
                                        </article>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- New -->
                        </div>
                    </div>
                </div>
            </div>

            <br />
        </div>
        <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
            <h5 class="placeholder-glow">
                <span class="placeholder col-12" style="height: 200px"></span>
            </h5>
        </div>
    </div>
</section>
